<template>
    <div class="container">
        <div class="con_title">汇总字段</div>
        <div class="filter_path">
            <div class="filter_btn" :class="{ active : active == 1}" @click="active = 1">品牌 <i class="el-icon-success"></i> </div>
            <div class="filter_btn" :class="{ active : active == 2}" @click="active = 2">商品名称 <i class="el-icon-success"></i> </div>
            <div class="filter_btn" :class="{ active : active == 3}" @click="active = 3">规格 <i class="el-icon-success"></i> </div>
            <div class="filter_btn" :class="{ active : active == 4}" @click="active = 4">等级 <i class="el-icon-success"></i> </div>
            <div class="filter_btn" :class="{ active : active == 5}" @click="active = 5">产地 <i class="el-icon-success"></i> </div>
            <div class="filter_btn" :class="{ active : active == 6}" @click="active = 6">长度 <i class="el-icon-success"></i> </div>
            <div class="filter_btn" :class="{ active : active == 7}" @click="active = 7">供应商 <i class="el-icon-success"></i> </div>
            <div class="filter_btn" :class="{ active : active == 8}" @click="active = 8">货柜 <i class="el-icon-success"></i> </div>
        </div>
        <div class="operate_row">
            <div class="row_title">库存汇总表</div>
            <div class="">
                <span class="excel_btn" @click="show_upload = !show_upload"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="table_path">
            <el-table :data="list" style="width: 100%" border height="100%" size="mini" header-cell-class-name="list_table_th">
                <el-table-column label="货柜"></el-table-column>
                <el-table-column label="品牌"></el-table-column>
                <el-table-column label="商品名称"></el-table-column>
                <el-table-column label="规格"></el-table-column>
                <el-table-column label="等级"></el-table-column>
                <el-table-column label="产地"></el-table-column>
                <el-table-column label="供应商"></el-table-column>
                <el-table-column label="订单量（立方）"></el-table-column>
                <el-table-column label="在途量（立方）"></el-table-column>
                <el-table-column label="库存量（立方）"></el-table-column>
            </el-table>
        </div>
        <div class="pagination_path">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <upload-execl :show.sync="show_upload"></upload-execl>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
        .con_title{ font-size:16px; font-weight:bold; color: #333333; margin-bottom: 8px; }
        .filter_path{
            padding: 10px; background-color: #F4F5F9; display: flex; align-items: center;
            .filter_btn{
                border: 1px solid #F7F8FA; border-radius:3px; position: relative; padding: 8px 18px; cursor: pointer; font-size: 14px;
                &.active{
                    border-color: #B21111;
                    & > i{ color: #B21111; }
                }
                & > i{ color: transparent; position: absolute; bottom: 2px; right: 2px; }
                & + .filter_path{ margin-left: 20px; }
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 20px 0 14px;
            .row_title{ font-size: 16px; color: #333333; font-weight:bold; }
            // .excel_btn{
            //     color: #8A8A8A; cursor: pointer;
            //     & + .excel_btn{ margin-left: 10px; }
            // }
        }
        .table_path{ flex: 1; }

    }
</style>
<script>
    import uploadExecl from '../../components/uploadExecl.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        components:{
            pagination,
            uploadExecl,
        },
        data(){
            return{
                params:{
                    keyword: "",
                    belong: "",
                    project: "",
                    per_page: 20
                },
                active : 1,
                last_page: 10,
                current_page: 1,
                total: 1000,
                list : [],
                // uploadExecl START
                show_upload : false,
                // uploadExecl END

            }
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
    }
</script>
